/**
 * Audit Summary Page - Placeholder
 */

import { ClipboardList } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ComingSoon } from '@/components';

export function AuditSummaryPage() {
  const { t } = useTranslation();
  return (
    <ComingSoon
      title={t('navigation.auditSummary')}
      icon={ClipboardList}
      description={t('comingSoon.auditSummaryDescription')}
    />
  );
}
